import { combineReducers } from "@reduxjs/toolkit";
import institutionaleSlice from "apps/Account/Pages/Institutional/ClientSideStates";
import adManagementSlice from "apps/CustomerPanel/Ad/ClientSideStates";
import alarmSlice from "apps/CustomerPanel/Alarm/ClientSideStates";
import contractSlice from "apps/CustomerPanel/Contract/ClientSideStates";
import favoriteSlice from "apps/CustomerPanel/Favorite/Pages/Ads/ClientSideStates";
import inviteSlice from "apps/CustomerPanel/Invite/ClientSideStates";
import invoiceSlice from "apps/CustomerPanel/Invoice/ClientSideStates";
import messageSlice from "apps/CustomerPanel/Message/ClientSideStates";
import portofolioSlice from "apps/CustomerPanel/MLS/Components/Portfolio/ClientSideStates";
import notificationSlice from "apps/CustomerPanel/Notification/ClientSideStates";
import profileSlice from "apps/CustomerPanel/Profile/ClientSideStates";
import competitorAnalysisReportSlice from "apps/CustomerPanel/Report/Components/CompetitorAnalysis/ClientSideStates";
import marketAnalysisReportSlice from "apps/CustomerPanel/Report/Components/MarketAnalysis/ClientSideStates";
import summaryReportSlice from "apps/CustomerPanel/Report/Components/Summary/ClientSideStates";
import userManagementSlice from "apps/CustomerPanel/User/ClientSideStates";
import newsSlice from "apps/News/Pages/NewsList/ClientSideStates";
import realStateSlice from "apps/RealState/ListItems/ClientStates";
import mapListSlice from "apps/RealState/MapItems/ClientStates";



const rootReducer = combineReducers({
   realState:realStateSlice.reducer,
   profile:profileSlice.reducer,
   institutional:institutionaleSlice.reducer,
   ad:adManagementSlice.reducer,
   invoice:invoiceSlice.reducer,
   userManagement:userManagementSlice.reducer,
   adFavorite:favoriteSlice.reducer,
   news:newsSlice.reducer,
   alarm:alarmSlice.reducer,
   notification:notificationSlice.reducer,
   portofolio:portofolioSlice.reducer,
   message:messageSlice.reducer,
   invite:inviteSlice.reducer,
   contract:contractSlice.reducer,
   summaryReport:summaryReportSlice.reducer,
   marketAnalysisRepor:marketAnalysisReportSlice.reducer,
   competitorAnalysisRepor:competitorAnalysisReportSlice.reducer,
   mapList:mapListSlice.reducer
  
  });
  
  export type RootState = ReturnType<typeof rootReducer>;
  
  export default rootReducer;